import { TableUIProvider } from "../../contexts/TableUIContext";
import Gallery from "./Gallery";

export default function GalleryWrapper() {
    return (
        <TableUIProvider>
            <Gallery />
        </TableUIProvider>
    );
}
